import {
    localRead,
    getBreadCrumbList,
    getHomeRoute,
    getNextRoute,
    setTagNavListInLocalstorage,
    getTagNavListFromLocalstorage,
    routeEqual,
    getRouteTitleHandled,
    routeHasExist,
    getMenuByRouter,
} from "@/library/utils";
import { routers } from "@/router/index";

import config from "@/config";
const { homeName } = config;

const closePage = (state, route) => {
    const nextRoute = getNextRoute(state.tagNavList, route);
    state.tagNavList = state.tagNavList.filter((item) => {
        return !routeEqual(item, route);
    });
    router.push(nextRoute);
};

export default {
    state: {
        breadCrumbList: [],
        sysWidth: document.documentElement.clientWidth,
        sysHeight: document.documentElement.clientHeight,
        collapsed: true,
        errorList: [],
        tagNavList: [],
        hasReadErrorPage: false,
        routers: [routers],
        homeRoute: {},
        roomName: "zhiops",
        cachePage: [],
        menuList: [],
        currentPageName: "",
        currentPath: [{ title: "首页", path: "", name: "main_index" }],
        submenu: {
            path: "/mian",
            name: "mian",
            redirect: "/mian",
            component: import("@/views/Main.vue"),
            meta: {
                icon: "md-desktop",
                title: "工作台",
            },
            children: [
                {
                    path: "/mian",
                    title: "工作台",
                    name: "main_index",
                    meta: { title: "监控首页", icon: "md-desktop" },
                    component: () => import("@/views/home/index.vue"),
                },
            ],
        },
        wsInstance: WebSocket,
    },
    getters: {
        menuList: (state, getters, rootState) =>
            getMenuByRouter(routers, rootState.user.access),
    },
    mutations: {
        setSubMenu(state, route) {
            state.submenu = route;
        },
        setBreadCrumb(state, route) {
            state.breadCrumbList = getBreadCrumbList(route, state.homeRoute);
        },
        setHomeRoute(state, routes) {
            state.homeRoute = getHomeRoute(routes, "main_index");
        },
        setCollapsed(state, bol) {
            state.collapsed = bol;
        },
        addError(state, error) {
            state.errorList.push(error);
        },
        setHasReadErrorLoggerStatus(state, status = true) {
            state.hasReadErrorPage = status;
        },
        createWsConnect(state, vm) {
            let userInfo = JSON.parse(localRead("userinfo"));
            if (userInfo.user_id) {
                if ("WebSocket" in window) {
                    console.log("初始化完成");
                } else {
                    console.log("当前浏览器不支持 H5 WebSocket 请更换浏览器");
                }
                try {
                    let ws_scheme =
                        window.location.protocol === "https:" ? "wss" : "ws";
                    const host = "v4.sumibuy.com" || window.location.host;
                    var wsInstance = new WebSocket(
                        ws_scheme +
                            "://" +
                            host +
                            "/ws/msg/" +
                            userInfo.username +
                            "/"
                    );

                    wsInstance.onopen = function () {
                        console.log("正在连接ws服务器...");
                    };
                    wsInstance.onerror = function () {
                        console.log("连接到 WebSocket 服务器失败");
                    };
                    //每次关闭或者刷新页面都会重新创建一个websocket对象。
                    wsInstance.onclose = function (ev) {
                        //需要发送断开链接
                        console.log("连接已关闭 " + ev.code + ev.reason);
                    };
                    //接收服务端发送的数据
                    wsInstance.onmessage = function (ev) {
                        //这边处理提醒框
                        var data = ev.data;
                        if (!("Notification" in window)) {
                            vm.$Message.warning(
                                "Sorry bro, your browser is not good enough to display notification"
                            );
                            return;
                        }
                        Notification.requestPermission().then(function (
                            permission
                        ) {
                            //permission 可能是是granted, denied, 或default.
                            if (permission == "granted") {
                                var notification = new Notification("提醒 ", {
                                    body: data,
                                    icon: "https://v4.sumibuy.com/resource/file/fd6b21a3-a363-4f79-a989-f9a0c630f004.png",
                                });
                                notification.onerror = function () {
                                    console.log("桌面通知发生错误!");
                                };
                                notification.onclick = function () {
                                    vm.$Message.warning("success,click");
                                    notification.close();
                                };
                                notification.onshow = function () {
                                    console.log("onshow 消息框显示时会被调用");
                                };
                            } else {
                                this.$Message.warning(
                                    "Sorry , your browser is not support notification"
                                );
                                return;
                            }
                        });
                    };
                    state.wsInstance = wsInstance;
                } catch (err) {
                    console.log("创建 WebSocket 对象失败 请检查服务器地址");
                }
            }
        },
        closeWsConnect(state) {
            state.wsInstance.close();
        },
        autoWsPING(state) {
            setInterval(function () {
                let userInfo = JSON.parse(localRead("userinfo"));
                if (userInfo.user_id) {
                    try {
                        let msg = {
                            user_id: userInfo.user_id,
                            username: userInfo.username,
                            message: "心跳发送连接",
                            type: "ping.message",
                        };
                        state.wsInstance.send(JSON.stringify(msg));
                    } catch (err) {
                        console.log(err, "心跳发送失败 原因请查看控制台");
                        throw err;
                    }
                }
            }, 60 * 1000);
        },
        setTagNavList(state, list) {
            let tagList = [];
            if (list) {
                tagList = [...list];
            } else tagList = getTagNavListFromLocalstorage() || [];
            if (tagList[0] && tagList[0].name !== homeName) tagList.shift();
            let homeTagIndex = tagList.findIndex(
                (item) => item.name === homeName
            );
            if (homeTagIndex > 0) {
                let homeTag = tagList.splice(homeTagIndex, 1)[0];
                tagList.unshift(homeTag);
            }
            state.tagNavList = tagList;
            setTagNavListInLocalstorage([...tagList]);
        },
        closeTag(state, route) {
            let tag = state.tagNavList.filter((item) =>
                routeEqual(item, route)
            );
            route = tag[0] ? tag[0] : null;
            if (!route) return;
            closePage(state, route);
        },
        addTag(state, { route, type = "unshift" }) {
            let router = getRouteTitleHandled(route);
            if (!routeHasExist(state.tagNavList, router)) {
                if (type === "push") state.tagNavList.push(router);
                else {
                    if (router.name === homeName)
                        state.tagNavList.unshift(router);
                    else state.tagNavList.splice(1, 0, router);
                }
                setTagNavListInLocalstorage([...state.tagNavList]);
            }
        },
    },
    actions: {
        handleCollapsed({ commit }, { collapsed }) {
            commit("setCollapsed", collapsed);
        },
        addErrorLog({ commit, rootState }, info) {
            if (!window.location.href.includes("error_logger_page"))
                commit("setHasReadErrorLoggerStatus", false);
            const {
                user: { token, userId, userName },
            } = rootState;
            let data = {
                ...info,
                time: Date.parse(new Date()),
                token,
                userId,
                userName,
            };
            commit("addError", data);
        },
    },
};
